import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import CookieBanner from '../components/CookieBanner/CookieBanner';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
  <CookieBanner />
  <Footer />
    </>
  );
}
